import { render, staticRenderFns } from "./DonutGraph.vue?vue&type=template&id=d0801470&"
import script from "./DonutGraph.vue?vue&type=script&lang=js&"
export * from "./DonutGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports